import React from 'react';
import {Helmet,HelmetProvider} from 'react-helmet-async';
import {Header,Footer} from '../components-static/Common';
import {TextButton} from '../components-static/Input';
import PropTypes from 'prop-types';
import moment from 'moment';
import {io} from 'socket.io-client';
import store from 'store';
import "../styles/turnstile-monitoring.scss";

export default class TurnstileMonitoring extends React.Component{

    successReset = 3;

    failReset = 10;

    state={
        southLabel:"",
        northLabel:"",
        turnstiles:[],
        error:"Not connected to server",
        demoMode:false,
        soundtrack:[
            {src:"/audio/Default.wav",type:"audio/wav",selected:false},
            {src:"/audio/1.mp3",type:"audio/mpeg",selected:true},
            {src:"/audio/3.ogg",type:"audio/ogg",selected:false},
            {src:"/audio/4.mp3",type:"audio/mpeg",selected:false},
            {src:"/audio/5.wav",type:"audio/wav",selected:false},
        ],
    }

    componentDidMount=()=>{
        this.setupSockets();
        this.setupSound();
        this.interval=setInterval(()=>{
            this.setIdle();
        },500);
        this.setState({init:true});
    }

    componentWillUnmount=()=>{
        if(this.interval){
            clearInterval(this.interval);
        }

        if(this.demoInterval){
            clearInterval(this.demoInterval);
        }
    }

    setIdle=()=>{
        let turnstiles = this.state.turnstiles;
        turnstiles = turnstiles.map(
          (item)=>{
              const successEnded = (moment().diff(item.dateTime,"seconds") >= this.successReset) && item.result == "Success";
              const failureEnded = (moment().diff(item.dateTime,"seconds") >= this.failReset) && (item.result == "Failed" || item.result == "Passback");

              if(successEnded || failureEnded){
                  item.action="Idle";
                  item.result="None";
              }

              return item;
          }
        );

        this.setState({
            turnstiles:turnstiles
        });
    }

    setupSockets=()=>{
        const ipConfig = require("../../config.json");
        this.socket = io(ipConfig.socketIP,{
            reconnectionDelayMax: 5000,
            withCredentials: true,
            extraHeaders:{
                "csrf-token": "turnstile-monitoring",
            },
            transports:["websocket"],
        });

        this.socket.on('connect',()=>{
            this.setState({sessionID:this.socket.id,error:""});
        });

        this.socket.on("disconnect",()=>{
            this.setState({error:"Not connected to server"});
        });

        this.socket.on("set-base-state",(content)=>{
            let hasError=false;
            this.setState({
              turnstiles:content.turnstiles.map((item)=>{
                  if(item.result == "Failed" || item.result == "Passback"){
                      hasError=true;
                  }
                  item.dateTime=moment().format("YYYY-MM-DDTHH:mm:ss");
                  return item;
              }),
              northLabel:content.northTowerLabel,
              southLabel:content.southTowerLabel
            });
            this.successReset=content.successReset;
            this.failReset=content.failReset;

            if(hasError){
                this.playAudio();
            }
        });

        this.socket.on("update-turnstile",(turnstile)=>{
            let turnstiles = this.state.turnstiles;
            for(var i=0; i<turnstiles.length; i++){
                if(turnstiles[i].id == turnstile.id){
                    for(var key in turnstile){
                        turnstiles[i][key] = turnstile[key];
                    }
                    turnstiles[i].dateTime = moment().format("YYYY-MM-DDTHH:mm:ss");
                    break;
                }
            }
            this.setState({turnstiles:turnstiles});

            if(turnstile.result == "Passback" || turnstile.result == "Failed"){
                this.playAudio();
            }
        });
    }

    setupSound=()=>{
        const index = store.get("monitoring-sound-index");
        if(!isNaN(index)){
            this.toggleSound(index);
        }
    }

    toggleSound=(index,playsound)=>{
        let soundtrack = this.state.soundtrack;
        for(var i=0; i<soundtrack.length; i++){
            soundtrack[i].selected = (i == index);
        }
        this.setState({soundtrack:soundtrack});
        store.set("monitoring-sound-index",index);

        if(playsound){
            setTimeout(()=>{
              this.playAudio();
            },100);
        }
    }

    playAudio=()=>{
        const audio = this.refs['audio'];
        audio.load();
        audio.currentTime = 0;
        audio.play();
    }

    onToggleDemo=()=>{
        const newMode = !this.state.demoMode;
        if(newMode){
            this.demoInterval = setInterval(()=>{
                this.socket.emit("demo-update-turnstile",{
                  socketId:this.socket.id
                });
            },1000);
        }
        else{
            if(this.demoInterval){
                clearInterval(this.demoInterval);
            }
        }
        this.setState({demoMode:newMode});
    }

    render=()=>{
        if(!this.state.init){
            return <div/>
        }
        const turnstiles=this.state.turnstiles;
        return(
            <HelmetProvider>
                <div className="monitoring-page-container">
                    <Helmet>
                        <title>{this.props.title}</title>
                        <meta name="viewport" content="width=device-width,initial-scale=1"/>
                        <meta name="viewport" content="height=device-height,initial-scale=1"/>
                    </Helmet>

                    <Header type="logo"/>

                    <div className="monitoring-container">
                        <div className="page-error" style={{
                              position:"absolute",
                              top:0,
                              left:0,
                              textAlign:"center"
                        }}>
                            {this.state.error}
                        </div>

                        <div className="north-tower-container">
                            <div className="north-tower-bg"/>
                            <div className="north-title">{this.state.southLabel}</div>
                            <div className="tower-turnstile">
                                {
                                    turnstiles.filter((item)=>{
                                        return (item.location == "south")
                                    }).map(
                                        (item,index)=>{
                                            return (
                                                <Turnstile key={index}
                                                           content={item}
                                                           />
                                            )
                                        }
                                    )
                                }
                            </div>
                        </div>

                        <div className="south-tower-container">
                            <div className="south-tower-bg"/>
                            <div className='south-title'>{this.state.northLabel}</div>
                            <div className="tower-turnstile">
                                {
                                  turnstiles.filter((item)=>{
                                      return (item.location == "north")
                                  }).map(
                                        (item,index)=>{
                                            return (
                                                <Turnstile key={index}
                                                           content={item}
                                                           />
                                            )
                                        }
                                    )
                                }
                            </div>
                        </div>

                        <div className="recept-desk-container">
                            <div className='tower-title'>Reception</div>
                            <div className="recept-desk-outer">
                                <div className="recept-desk-inner" onClick={this.onToggleDemo}>
                                    {
                                        (this.state.demoMode)
                                            ?
                                            <span style={{fontSize:"10px"}}><b>Demo Mode Active</b><br/>Click here to disable</span>
                                            :
                                            null
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="sound-container">
                            <div className={"sound-bg" + (this.state.soundOpen ? " open" : "")}>
                                <TextButton style={{fontSize:"14px"}} onClick={()=>{this.setState({soundOpen:!this.state.soundOpen})}}>
                                    {
                                        (!this.state.soundOpen)
                                            ?
                                            "Sound not playing?"
                                            :
                                            "Hide sound options"
                                    }
                                </TextButton>

                                <div className={"sound-content" + (this.state.soundOpen ? " open" : "")}>
                                    <div className="sound-instruction">Click play once to activate sound</div>
                                    <audio controls={true} ref="audio">
                                        {
                                            this.state.soundtrack.map(
                                                (item,index)=>{
                                                    if(!item.selected){
                                                        return null;
                                                    }
                                                    return (
                                                        <source key={index} src={item.src} type={item.type}/>
                                                    )
                                                }
                                            )
                                        }
                                    </audio>

                                    <div className="sound-select">
                                        <div className="sound-instruction">Choose soundtrack below</div>
                                        <div>
                                            {
                                                this.state.soundtrack.map(
                                                    (item,index)=>{
                                                        return (
                                                            <div key={index} className={"sound-button" + ((item.selected) ? " selected" : "")} onClick={()=>{this.toggleSound(index,true)}}>
                                                                {index}
                                                            </div>
                                                        )
                                                    }
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <Footer type="half" style={{background:"transparent"}}/>
                </div>
            </HelmetProvider>
        )
    }
}

class Turnstile extends React.Component{
    render=()=>{
        const content=this.props.content;
        return(
            <div className={"turnstile-container " + content.action + " " + content.result}>

                {
                    (content.double || content.type=="left")
                        ?
                        <div className="left-arm">
                            <div className={"turnstile-base-container" + ((content.type !="left" && content.double) ? " double" : "")}>
                                <div className="turnstile-top">
                                    <div className="turnstile-sensor">
                                        <div className="turnstile-scanner"/>
                                    </div>
                                </div>
                                <div className="turnstile-base"/>
                                <div className="turnstile-bottom">
                                    <div className="turnstile-sensor">
                                        <div className="turnstile-scanner"/>
                                    </div>
                                </div>
                            </div>
                            <div className="door">
                                <div className="door-motor"/>
                                <div className="left-door"/>
                            </div>
                        </div>
                        :
                        null
                }

                {
                    (content.double || content.type=="right")
                        ?
                        <div className="right-arm">
                            <div className="door">
                                <div className="right-door"/>
                                <div className="door-motor"/>
                            </div>
                            <div className={"turnstile-base-container" + ((content.type !="right" && content.double) ? " double" : "")}>
                                <div className="turnstile-top">
                                    <div className="turnstile-sensor">
                                        <div className="turnstile-scanner"/>
                                    </div>
                                </div>
                                <div className="turnstile-base"/>
                                <div className="turnstile-bottom">
                                    <div className="turnstile-sensor">
                                        <div className="turnstile-scanner"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        null
                }

                <div className={"movement-container " + content.action + " " + ((content.double) ? "double" : content.type) + " " + content.result}>
                    <img className="movement-indicator success" src="/images/turnstile/down-arrow-green.png"/>

                    <img className="movement-indicator passback" src="/images/turnstile/cross-orange.png"/>

                    <img className="movement-indicator failed" src="/images/turnstile/cross-red.png"/>
                </div>

                <div className={"status-text " + (content.type) + (content.double ? " double" : "")}>
                    <div className="name">{content.label}</div>
                    <div className="status">
                        {
                            (content.result == "Failed" || content.result == "Passback")
                              ?
                              content.result
                              :
                              content.action
                        }
                    </div>
                    {
                        (content.action == "Idle" || content.action == "Offline" || !(content.userType))
                            ?
                            <div className="user" style={{opacity:0}}>None</div>
                            :
                            <div className="user">{content.userType}</div>
                    }
                </div>
            </div>
        )
    }
}
